export const EQIP_PRACTICES_CONSERVATION = ['yes', 'no'] as const
export type EqipPracticesConservation = typeof EQIP_PRACTICES_CONSERVATION[number]
